module.exports = __webpack_public_path__ + "static/media/Contributor.a186f256.png";